export const CONTROL_COLUMN_WIDTH = '3.5rem';
export const MENU_COLUMN_WIDTH = '4rem';
export const ICON_ACTION_WIDTH_REM = 2.5;
export const ACTIONS_CELL_PADDING_REM = 1.5;
export const FLEX_COLUMN_MIN_WIDTH = '9rem';
